export const watchData = [{
        "id": "1",
        "product": "Watch",
        "image": "/assets/Watch/1.png",
        "brand": "Apple",
        "model": "Watch Series 7",
        "price": "399.00",
        "category": "Wearable",
        "description": "The latest Apple Watch with a larger display and advanced health features."
    },
    {
        "id": "2",
        "product": "Watch",
        "image": "/assets/Watch/2.jpg",
        "brand": "Samsung",
        "model": "Galaxy Watch 4",
        "price": "299.99",
        "category": "Wearable",
        "description": "A Samsung smartwatch with comprehensive health tracking and versatile design."
    },
    {
        "id": "3",
        "product": "Watch",
        "image": "/assets/Watch/3.jpg",
        "brand": "Fitbit",
        "model": "Versa 3",
        "price": "229.00",
        "category": "Wearable",
        "description": "A Fitbit smartwatch with built-in GPS and fitness tracking capabilities."
    },
    {
        "id": "4",
        "product": "Watch",
        "image": "/assets/Watch/4.jpg",
        "brand": "Garmin",
        "model": "Forerunner 945",
        "price": "599.50",
        "category": "Wearable",
        "description": "A high-end Garmin GPS watch designed for serious athletes and outdoor enthusiasts."
    },
    {
        "id": "5",
        "product": "Watch",
        "image": "/assets/Watch/5.jpg",
        "brand": "Fossil",
        "model": "Gen 5",
        "price": "249.00",
        "category": "Wearable",
        "description": "A stylish Fossil smartwatch with Wear OS and customizable watch faces."
    },
    {
        "id": "6",
        "product": "Watch",
        "image": "/assets/Watch/6.jpg",
        "brand": "Casio",
        "model": "G-Shock GA-2100",
        "price": "129.99",
        "category": "Wearable",
        "description": "A rugged and iconic G-Shock watch with a modern and slim design."
    },
    {
        "id": "7",
        "product": "Watch",
        "image": "/assets/Watch/7.jpg",
        "brand": "TAG Heuer",
        "model": "Carrera Calibre Heuer 02",
        "price": "5999.00",
        "category": "Luxury",
        "description": "A luxurious TAG Heuer mechanical watch with a sporty and sophisticated design."
    },
    {
        "id": "8",
        "product": "Watch",
        "image": "/assets/Watch/8.jpg",
        "brand": "Timex",
        "model": "Weekender Chronograph",
        "price": "89.00",
        "category": "Wearable",
        "description": "A versatile Timex watch with a chronograph function and interchangeable straps."
    },
    {
        "id": "9",
        "product": "Watch",
        "image": "/assets/Watch/9.jpg",
        "brand": "Citizen",
        "model": "Eco-Drive Promaster",
        "price": "299.99",
        "category": "Wearable",
        "description": "A Citizen watch powered by light with durable construction for outdoor adventures."
    },
    {
        "id": "10",
        "product": "Watch",
        "image": "/assets/Watch/10.jpg",
        "brand": "Seiko",
        "model": "SKX007",
        "price": "199.50",
        "category": "Wearable",
        "description": "A classic Seiko diver's watch known for its reliability and timeless design."
    },
    {
        "id": "11",
        "product": "Watch",
        "image": "/assets/Watch/11.jpg",
        "brand": "Michael Kors",
        "model": "Access Lexington 2",
        "price": "279.00",
        "category": "Wearable",
        "description": "A Michael Kors smartwatch with a luxurious look and smart functionalities."
    },
    {
        "id": "12",
        "product": "Watch",
        "image": "/assets/Watch/12.jpg",
        "brand": "Huawei",
        "model": "Watch GT 3",
        "price": "199.00",
        "category": "Wearable",
        "description": "A Huawei smartwatch with long battery life and health monitoring features."
    }
]